<div class="eiq-custom-options-form">
  <div class="question-form__array with-actions">
    <div class="eiq-custom-options-form__header">
      <span class="fs__sm fw__600">Options</span>
      <mat-checkbox color="primary" [formControl]="randomized()" [checked]="randomized().value" [labelPosition]="'before'">
        <span class="fs__sm fw__500">Randomized</span>
      </mat-checkbox>
    </div>

    <div cdkDropList class="question-form_array_list" (cdkDropListDropped)="drop($event)">
      @for (optionCtrl of customOptions().controls; track $index) {
        <div cdkDrag class="question-form_array_draggable">
          <div class="question-form__array__input">
            <div *cdkDragPlaceholder class="drag-placeholder"></div>
            <fa-icon [class.eiq-hide]="customOptions().controls.length === 1" [icon]="faGripDotsVertical" title="Re-order option" cdkDragHandle></fa-icon>

            <empathy-text-editor
              [id]="optionCtrl.value.id"
              [control]="optionCtrl.get('text')"
              [autofocus]="justAddedOptionId === optionCtrl.value.id"
              [stopDefaultTab]="true"
              [hasMedia]="false"
              [splitOnPaste]="true"
              (tab)="onAddOption($last, $index)"
              (paste)="onPaste($event, $index)"
            >
              <div slot="prefix" class="eiq-id-badge">
                <span>{{ optionCtrl.value.id }}</span>
              </div>

              <div slot="suffix" class="actions">
                @if (customOptions().controls.length > 1) {
                  <button mat-icon-button color="warn" title="Delete Option" (click)="onRemoveAt($index)">
                    <fa-icon [icon]="faTrashCan"></fa-icon>
                  </button>
                }
              </div>
            </empathy-text-editor>
          </div>
        </div>
      }
    </div>

    <div class="footer">
      <button mat-button color="primary" (click)="onAddOption(true)">
        <fa-icon [icon]="faPlus"></fa-icon>
        New Option
      </button>
    </div>
  </div>
</div>
